interface ExerciseActionHintProps {
  message?: string | null
}

export function ExerciseActionHint({ message }: ExerciseActionHintProps) {
  if (!message) return null

  return (
    <p
      className="text-sm text-amber-600 dark:text-amber-400"
      role="status"
      aria-live="polite"
      data-testid="exercise-action-hint"
    >
      {message}
    </p>
  )
}
